import CloseAlertModal from 'features/Weather/features/WeatherAlerts/components/Modals/CloseAlertModal/CloseAlertModal';
import { selectShowCloseAlertModal } from 'features/Weather/features/WeatherAlerts/features/AlertList/state/selectors/alertListSelectors';
import { setShowCloseAlertModal } from 'features/Weather/features/WeatherAlerts/features/AlertList/state/slices/alertListSlice';
import { closeAlertThunk } from 'features/Weather/features/WeatherAlerts/features/AlertList/state/thunks/alertListThunks';
import FemaOptions from 'features/Weather/features/WeatherAlerts/features/FemaAlertList/components/FemaOptions';
import {
  getAlertSeverityColor,
  getAlertSeverityLabel,
} from 'features/Weather/features/WeatherAlerts/utils/alertSeverity.utils';
import { isFemaAlert } from 'features/Weather/features/WeatherAlerts/utils/isFemaAlert.utils';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

/**
 * @import { Alert } from 'features/Weather/features/WeatherAlerts/types/alerts.types';
 * @param {{ variant: string, alert: Alert, canCloseAlert: boolean, canDeleteAlerts: boolean }} props
 */

const AlertWidgetRow = ({ variant, alert, canCloseAlert, canDeleteAlerts }) => {
  const dispatch = useDispatch();
  const showCloseAlertModal = useSelector(selectShowCloseAlertModal);
  const isCompact = variant === '1x';
  const compactCellPaddingClass = isCompact ? 'px-1 py-1' : 'px-2 py-1';
  const severityColClass = isCompact ? 'col-3' : 'col-2';
  const typeColClass = isCompact ? 'col-4' : 'col-3';
  const senderColClass = alert.alertSource === 'fema' ? 'col-3' : 'col-4';
  const textStyle = {
    fontSize: isCompact ? '0.82rem' : '0.85rem',
    lineHeight: isCompact ? 1.15 : 1.2,
    minWidth: 0,
    wordBreak: 'break-word',
  };
  const severityStyle = {
    ...textStyle,
    wordBreak: 'normal',
  };
  const senderStyle = {
    ...textStyle,
    wordBreak: 'normal',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };
  const hasFemaSource = isFemaAlert(alert);

  return (
    <div className="row g-0 flex-nowrap align-items-start overflow-hidden">
      <div
        className="col-1 align-self-stretch"
        style={{
          backgroundColor: getAlertSeverityColor(alert.severity),
          minHeight: isCompact ? 52 : 48,
          minWidth: variant === '1x' ? 24 : 30,
          maxWidth: variant === '1x' ? 24 : 30,
        }}
      />
      <p className={`${severityColClass} mb-0 ${compactCellPaddingClass}`} style={severityStyle}>
        {alert.severityLabel ?? getAlertSeverityLabel(alert.severity)}
      </p>
      <p className={`${typeColClass} mb-0 ${compactCellPaddingClass}`} style={textStyle}>
        <span>{alert.description}</span>
        {hasFemaSource ? <span className="badge bg-warning text-dark ms-1">FEMA IPAWS</span> : null}
      </p>
      <p
        className={`${senderColClass} mb-0 ${compactCellPaddingClass}`}
        style={senderStyle}
        title={alert.nws_office}
      >
        {alert.nws_office}
      </p>
      {/* Only a stored IPAWS message has actions; the sender column gives up the column. */}
      {alert.alertSource === 'fema' ? (
        <div className="col-1 px-1 py-1" onClick={(event) => event.stopPropagation()}>
          <FemaOptions alert={alert} />
        </div>
      ) : null}
      {variant !== '1x' &&
        (canCloseAlert ? (
          <Button
            className="col-2 px-2 py-1 rounded-3 h-auto align-self-center"
            style={{ fontSize: '0.8rem', lineHeight: 1.1 }}
            onClick={() => dispatch(setShowCloseAlertModal(true))}
            variant="success"
          >
            Close
          </Button>
        ) : null)}
      <CloseAlertModal
        show={showCloseAlertModal}
        alert={alert}
        onClose={() => dispatch(setShowCloseAlertModal(false))}
        onConfirm={(notes) => {
          if (!canDeleteAlerts) return;
          dispatch(closeAlertThunk({ alertId: alert.message_id, notes: notes }));
        }}
      />
    </div>
  );
};

export default AlertWidgetRow;
